export default __webpack_public_path__ + "static/Card19-ef665f044cfab6ade6a681f63f4aa295.png";